export type PaymentCreditCard = {
  id: number
  brand: string
  name: string
  card_mask: string
  expiration_month: string
  expiration_year: string
  created_at: string
  address_street: string
  address_number: string
  address_neighborhood: string
  address_zip: string
  address_city: string
  address_state: string
  requires_reregistration: boolean
}

export type PaymentCreditCardCreate = Omit<PaymentCreditCard, 'id' | 'created_at' | 'requires_reregistration'> & {
  token?: string
  pagarme_card_token?: string
  replaces_card_id?: number
  cpf: string
}

export type PaymentCreditCardSummary = Pick<
  PaymentCreditCard,
  'id' | 'brand' | 'card_mask' | 'expiration_month' | 'expiration_year'
>

export type PaymentCardGateway = {
  pagarme: {
    enabled: boolean
    public_key: string | null
    missing_profile: string[]
  }
}

export type PaymentCredits = {
  balance: string
}

export type PaymentHistory = {
  id: number
  status: PaymentStatus
  method: PaymentMethods
  value: number
  created_at: string
  payment_transaction_id: string
  wallet_value: string
  external_value: string
}

export enum PaymentMethodEnum {
  CREDIT_CARD = 'CREDIT_CARD',
  PIX = 'PIX',
  CREDITS = 'CREDITS',
}

export const PaymentLabels = {
  [PaymentMethodEnum.CREDITS]: 'Carteira',
  [PaymentMethodEnum.CREDIT_CARD]: 'Cartão de Crédito',
  [PaymentMethodEnum.PIX]: 'Pix',
}

export type PaymentStatus = 'PENDING' | 'AUTHORIZED' | 'COMPLETED' | 'FAILED' | 'CANCELED'
export type PaymentMethods = (typeof PaymentMethodEnum)[keyof typeof PaymentMethodEnum]
export type ChargingPaymentMethod = Exclude<PaymentMethods, PaymentMethodEnum.CREDITS>

export type PaymentProduct = {
  id: number
  name: string
  amount: number
  discount: number
}

export type PaymentProductCreate = Omit<PaymentProduct, 'id'>
